import React, { useState, useEffect } from 'react';
import { getAllBlogs, formatBlogDate } from '../../common/blogStore';

function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    getAllBlogs()
      .then((blogs) => setBlogs(blogs.slice(0, 3)))
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="blog style2">
      <div className="container">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div>
              <span className="sub-title main-color mb-5">Blogumuz</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                  Son <span className="fw-200">Yazılar.</span>
                </span>
              </h3>
            </div>
            <div className="ml-auto vi-more">
              <a href="/blog-classic" className="butn butn-sm butn-bord radius-30">
                <span>Tümünü Gör</span>
              </a>
              <span className="icon ti-arrow-top-right"></span>
            </div>
          </div>
        </div>
        <div className="row">
          {blogs.map((blog) => (
            <div key={blog.id} className="col-lg-4">
              <div className="item md-mb50">
                <div className="info sub-title p-color d-flex align-items-center mb-20">
                  <div>
                    <a href="/blog-classic">Yazar: {blog.author || 'Admin'}</a>
                  </div>
                  <div className="ml-30">
                    <a href={`/blog-details/${blog.id}`}>
                      {formatBlogDate(blog.date)}
                    </a>
                  </div>
                </div>
                <div className="img fit-img">
                  <img src={blog.coverImg || '/assets/imgs/blog/1.jpg'} alt="" />
                </div>
                <div className="cont pt-30">
                  <h5>{blog.title} {blog.titleHighlight}</h5>
                  <a
                    href={`/blog-details/${blog.id}`}
                    className="butn-crev d-flex align-items-center mt-30"
                  >
                    <span className="hover-this">
                      <span className="circle hover-anim">
                        <i className="ti-arrow-top-right"></i>
                      </span>
                    </span>
                    <span className="text">Devamını Oku</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Blog;
